module.exports = __webpack_public_path__ + "img/pic_kong@2x.8790a5bc.png";